import { Capacitor } from '@capacitor/core';

/**
 * Configuration de l'UI native Android/iOS (barre d'état, clavier).
 * Sans effet sur le web : toutes les fonctions sont des no-op hors Capacitor.
 */

const isNative = Capacitor.isNativePlatform();

/**
 * Aligne la barre d'état système sur le thème courant de l'app.
 * @param {boolean} dark  true si l'app est en mode sombre.
 */
export const syncStatusBar = async (dark) => {
  if (!isNative) return;
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    // Style.Dark = texte clair (fond sombre) ; Style.Light = texte sombre.
    await StatusBar.setStyle({ style: dark ? Style.Dark : Style.Light });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: dark ? '#0f172a' : '#ffffff' });
      // L'app dessine derrière la barre d'état (gestion via safe-area CSS).
      await StatusBar.setOverlaysWebView({ overlay: false });
    }
  } catch (e) {
    console.warn('StatusBar indisponible:', e?.message);
  }
};

/** Configure le clavier (ne pas redimensionner brutalement le webview). */
export const initKeyboard = async () => {
  if (!isNative) return;
  try {
    const { Keyboard, KeyboardResize } = await import('@capacitor/keyboard');
    await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
    await Keyboard.setScroll({ isDisabled: false });
  } catch (e) {
    console.warn('Keyboard indisponible:', e?.message);
  }
};

/** Détecte le thème sombre courant (classe .dark sur <html>). */
export const isDarkTheme = () =>
  typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
